var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import { Alert } from "@brushfire/ui";
var SignatureResponse = function (_a) {
    var _b;
    var eventData = _a.eventData, path = _a.path;
    var location = useLocation();
    var queryParams = new URLSearchParams(location.search.toLowerCase());
    var paramsError = (_b = queryParams.get("error")) !== null && _b !== void 0 ? _b : "";
    if (paramsError) {
        return (_jsx("div", __assign({ className: "auto-group" }, { children: _jsxs(Alert, __assign({ purpose: "danger" }, { children: [_jsx("h4", { children: "Sorry!" }), _jsxs("p", { children: ["There was an error while saving your signature: ", paramsError] }), _jsx("p", __assign({ className: "m-bottom-0" }, { children: "Please click on the link in your email and try again." }))] })) })));
    }
    return (_jsx("div", __assign({ className: "auto-group" }, { children: _jsxs(Alert, __assign({ purpose: "success" }, { children: [_jsx("h4", { children: "Thank you!" }), _jsx("p", __assign({ className: "m-bottom-0" }, { children: "Your signature has been saved! You may close this window. You're done!" }))] })) })));
};
export default SignatureResponse;
